//import  NaCodeMaintenanceApiURLs  from '../../../../apiUrls/NaCodeMaintenanceApiUrls'
import EquipmentMasterApiUrls from "../../../../apiUrls/EquipmentMasterApiUrls"
import { CodeMaintenanceType } from 'src/constants/nacodemaintenance'
import { components} from 'cng-web-lib'
import PropTypes from 'prop-types'
import React from 'react'
import { FileForUserGetPartyId } from 'src/common/FileForUserCommon'

const {
  form: { field: { CngServerSideAutocompleteField } },
} = components

/**
 *
 * @visibleName Code maintenance autocomplete
 */
function NaEquipmentMasterAutocompleteField(props, codeMaintenanceType) {
  const { lookupProps = {}, ...lookupAutocompleteProps } = props
  const { filters = [], ...otherLookupProps } = lookupProps

  return (
    <CngServerSideAutocompleteField
      {...lookupAutocompleteProps}
      minFilterChars={1}
      debounceInterval={1000}
      openOnFocus={false}
      onMouseDownCapture={(e) => e.stopPropagation()}
      searchableFields={['equipmentId']}
      lookupPageableProps={{
        customData: { 'filters': filters },
        url: EquipmentMasterApiUrls.GET,
        label: 'equipmentId',
        value: 'equipmentId',
        filters: [
          ...filters
        ],
        pageSize: 100,
        ...otherLookupProps
      }}
    />
  )
}

NaEquipmentMasterAutocompleteField.propTypes = {
  /** @ignore */
  codeMaintenanceType: PropTypes.oneOf(Object.values(CodeMaintenanceType))
    .isRequired,
  /** @ignore */
  lookupProps: PropTypes.object
}

export default NaEquipmentMasterAutocompleteField
